/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiCreatePageViewResponseFromJSON(json) {
    return ApiCreatePageViewResponseFromJSONTyped(json, false);
}
export function ApiCreatePageViewResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pageviewKey': !exists(json, 'pageviewKey') ? undefined : json['pageviewKey'],
    };
}
export function ApiCreatePageViewResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pageviewKey': value.pageviewKey,
    };
}
